import React, {useCallback, useEffect} from 'react';

import Html from 'helpers/Html';
import Tools from 'helpers/Tools';
import useSession from 'hooks/useSession';
import useSetting from 'hooks/useSetting';
import useColor from 'hooks/useColor';
import useGroup from 'hooks/useGroup';

const classRect = 'selection';
let ruleMove = false;
let position = {
	x1: 0,
	y1: 0,
	x2: 0,
	y2: 0,
	initial: {
		x1: 0,
		y1: 0,
		x2: 0,
		y2: 0
	}
};

function Select(props) {
	let {
		active = false, disabled = false, wrapper, currentZoom
	} = props;


	const {
		saveSelection
	} = useSetting();


	const {
		setup,
		getPixelValue
	} = useSession();


	const {
		setCurrent
	} = useColor();


	const {
		moveGroup
	} = useGroup();


	const updateRender = useCallback(() => {
		let elementHTML = wrapper.current;
		let rect = elementHTML.querySelector('.' + classRect);
		if (rect !== null) {
			if (
				position.x1 === 0 &&
				position.y1 === 0 &&
				position.x2 === 0 &&
				position.y2 === 0
			) {
				rect.style.left = '0px';
				rect.style.top = '0px';
				rect.style.width = '0px';
				rect.style.height = '0px';
				return
			}
			let x = position.x1;
			let y = position.y1;
			let width = (position.x2 - position.x1);
			let height = (position.y2 - position.y1);

			rect.style.left = parseInt(x * currentZoom, 10) + 'px';
			rect.style.top = parseInt(y * currentZoom, 10) + 'px';
			rect.style.width = parseInt(width * currentZoom, 10) + 'px';
			rect.style.height = parseInt(height * currentZoom, 10) + 'px';
		}
	}, [currentZoom, setup.type]);

	const updatePosition = useCallback((index, event, saveInitial = true) => {
		let x = event.offsetX;
		let y = event.offsetY;

		position['x' + index] = x;
		position['y' + index] = y;


		let borderX = getPixelValue(setup.marginVertical);
		let borderY = getPixelValue(setup.marginHorizontal);
		let stepX = (getPixelValue(setup.domino.size.thickness) + borderX);
		let stepY = (getPixelValue(setup.domino.size.width) + borderY);
		let dominoWidth = getPixelValue(setup.domino.size.thickness);
		let dominoHeight = getPixelValue(setup.domino.size.width);

		if (setup.type === 2) {
			stepX = (getPixelValue(setup.domino.size.width) + borderX);
			stepY = (getPixelValue(setup.domino.size.thickness) + borderY);
			dominoWidth = getPixelValue(setup.domino.size.width);
			dominoHeight = getPixelValue(setup.domino.size.thickness);
		}

		if (setup.type === 3) {
			borderY = 1;
			stepX = (getPixelValue(setup.domino.size.width) + borderX);
			stepY = (getPixelValue(setup.domino.size.heightFallWall) + borderY);
			dominoWidth = getPixelValue(setup.domino.size.width);
			dominoHeight = getPixelValue(setup.domino.size.heightFallWall);
		}

		position['x' + index] = Tools.round(position['x' + index], stepX);
		position['y' + index] = Tools.round(position['y' + index], stepY);

		position.x2 -= borderX;
		position.y2 -= borderY;

		position.initial['x' + index] = position['x' + index];
		position.initial['y' + index] = position['y' + index];

		saveSelection(position);
		updateRender();
	}, [updateRender, setup.type]);

	const resetPosition = useCallback(() => {
		position.x1 = false;
		position.y1 = false;
		position.x2 = false;
		position.y2 = false;
		position.initial.x1 = false;
		position.initial.y1 = false;
		position.initial.x2 = false;
		position.initial.y2 = false;

		saveSelection(position);
		updateRender();
	}, [updateRender]);

	const checkActive = useCallback((elm, checkRule = false) => {
		if (Html.hasSomeParentTheClass(elm, 'btntool')) {
			return false;
		}

		if (Html.hasSomeParentTheClass(elm, 'settings-buttons-container')) {
			return false;
		}

		if (moveGroup) {
			return false;
		}
		if (!active) {
			return false;
		}
		if (checkRule && !ruleMove) {
			return false;
		}
		return true;
	}, [moveGroup, active, ruleMove]);

	const onMove = useCallback((evt) => {
		if (!checkActive(evt.target, true)) {
			return;
		}
		updatePosition(2, evt, true);
		//console.log(evt);
	}, [active, updatePosition, checkActive]);

	const onUp = useCallback((evt) => {
		if (!checkActive(evt.target)) {
			return;
		}
		//console.log('onUp');
		ruleMove = false;
		setCurrent(false);

	}, [active, updatePosition, checkActive]);

	const onDown = useCallback((evt) => {
		if (!checkActive(evt.target)) {
			return;
		}
		//console.log('onDown');
		ruleMove = true;

		updatePosition(1, evt);
	}, [active, updatePosition, checkActive]);

	/*useEffect(() => {
		let elementHTML = wrapper.current;
		let rect = elementHTML.querySelector('.' + classRect);
		if (rect !== null) {
			updatePosition(1, {
				offsetX: position.initial.x1 * currentZoom, offsetY: position.initial.y1 * currentZoom
			}, false);
			updatePosition(2, {
				offsetX: position.initial.x2 * currentZoom, offsetY: position.initial.y2 * currentZoom
			}, false);
		}

	}, [currentZoom, updatePosition]);*/

	useEffect(() => {
		resetPosition();
	}, [setup.type])


	useEffect(() => {
		let elementHTML = wrapper.current;
		let rect = elementHTML.querySelector('.' + classRect);
		if (elementHTML !== null) {
			if (active) {
				if (rect === null) {

					let newRect = document.createElement('div');
					newRect.setAttribute('class', classRect);
					elementHTML.append(newRect);

				}
			}
		}

		if (active === false) {
			saveSelection({
				x1: false,
				x2: false,
				y1: false,
				y2: false
			});
		}

	}, [active])

	useEffect(() => {
		const element = wrapper.current
		element.addEventListener('mousemove', onMove, false);
		element.addEventListener('mouseup', onUp, false);
		element.addEventListener('mousedown', onDown, false);

		return () => {
			element.removeEventListener('mousemove', onMove);
			element.removeEventListener('mouseup', onUp);
			element.removeEventListener('mousedown', onDown);
		}
	}, [wrapper, onMove, onUp, onDown, checkActive]);

	return (
		<button
			type="button"
			className={'btntool selecttool btn btn-primary p-0' + (active ? ' active' : '') + (disabled ? ' disabled' : '')}
			onClick={() => {
				let nextActive = active ? 4 : 3;
				if (nextActive === 4) {
					let elementHTML = wrapper.current;
					let rect = elementHTML.querySelector('.' + classRect);
					if (elementHTML !== null) {
						rect.remove();
					}
				}
				props.setActive(nextActive);
			}}
		>
			{active && (
				<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none"
				     strokeLinecap="round" strokeLinejoin="round"
				     className="cancel-select"
				>
					<line x1="18" y1="6" x2="6" y2="18"></line>
					<line x1="6" y1="6" x2="18" y2="18"></line>
				</svg>
			)}
			{!active && (
				<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none"
				     strokeLinecap="round" strokeLinejoin="round">
					<path d="M3 3l7.07 16.97 2.51-7.39 7.39-2.51L3 3z"></path>
					<path d="M13 13l6 6"></path>
				</svg>
			)}
		</button>);
}

export default Select;
